import axios, { AxiosInstance, AxiosResponse } from 'axios';
import qs from 'qs';
import refreshToken from '../cognito/refreshToken';

const apiClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

const validateToken = async (): Promise<void> => {
  try {
    await refreshToken();
  } catch (error) {
    console.error(error);
    throw error;
  }
}

const reqProvider = {
  async get(url: string, params?: object): Promise<AxiosResponse> {
    try {
      const queryString = params ? `?${qs.stringify(params)}` : '';
      return await apiClient.get(`${url}${queryString}`);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async post(url: string, data: object | string | number): Promise<AxiosResponse> {
    try {
      return await apiClient.post(url, data);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async put(url: string, data: object | string | number): Promise<AxiosResponse> {
    try {
      return await apiClient.put(url, data);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async delete(url: string): Promise<AxiosResponse> {
    try {
      return await apiClient.delete(url);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default reqProvider;